module.exports = __webpack_public_path__ + "static/media/bubblewoods.62cf3324.png";